module.exports = __webpack_public_path__ + "static/furniture-listlink-banner-right-section-2d06782cf7132fdb1ea5df9af22535e7.png";